import { useMemo } from 'react';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { useLivePageMode } from '@confluence/live-pages-utils/entry-points/useLivePagesStore.ts';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage.ts';

export type PageAnalyticsAttributes = {
	isLivePage: boolean;
	pageMode: 'view' | 'edit';
};

export const usePageAnalyticsAttributes = (): PageAnalyticsAttributes => {
	const isLivePage = useIsCurrentPageLive();
	const [{ mode: livePageMode }] = useLivePageMode();
	const isEditorPage = useIsEditorPage();

	return useMemo((): PageAnalyticsAttributes => {
		if (isLivePage) {
			return {
				isLivePage,
				pageMode: livePageMode || 'view', // 'edit' or 'view' for live pages
			};
		}
		return {
			isLivePage,
			pageMode: isEditorPage ? 'edit' : 'view', // 'edit' or 'view' for classic pages
		};
	}, [isLivePage, livePageMode, isEditorPage]);
};
